export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_4.f74418e9.mp3";